import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { CurrentUserService } from './current-user.service';
import { NotificationService } from './notification.service';
import { Observable } from 'rxjs';
import { UserLoggedIn } from '../models/user-login.model';
import { ModuleSelectionService } from '../../modules/users/services/module-selection.service';

@Injectable({
  providedIn: 'root',
})
export class LoginActivate implements CanActivate {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private currentUserService: CurrentUserService,
    private notificationService: NotificationService,
    private moduleSelectionService: ModuleSelectionService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    let userString = localStorage.getItem(this.currentUser);

    if (userString == null || userString == 'null') {
      // User not logged in - allow access to login page
      return true;
    } else {
      // User already logged in - redirect to appropriate landing page
      const user: UserLoggedIn = JSON.parse(userString);

      // Get the appropriate redirect URL based on user's module and role
      const redirectUrl = this.moduleSelectionService.getModuleRedirectUrl(
        user.moduleId,
        user.roleId
      );

      this.router.navigate([redirectUrl]);
      return false;
    }
  }

  private currentUser: string = 'currentUser';
}
